// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header {\n  background-color: white; }\n\nheader.Headerlanding_page, header.Headererror {\n  background-color: #E6F5EE; }\n\nheader.Headercart {\n  background-color: #F6EBE7; }\n\n@media screen and (max-width: 500px) {\n  header.Headerdetail {\n    background-color: #FEF8F5; } }\n", ""]);
// Exports
module.exports = exports;
